<template>
  <div id="app">
    <Header></Header>
    <router-view/>
    <Footer></Footer>
    <!-- <GoTop></GoTop> -->
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  .pc-container{
    width: 1200px;
    margin: 0 auto;
  }
 .swiper-pagination-bullet{
    width: 160px !important;
    height: 4px !important;
    border-radius: 0 !important;
    background: rgb(216, 206, 206) !important;
  }
  .swiper-container-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet{
    margin: 0 2px;
  }
  .one-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.two-text {
    text-overflow: ellipsis;
    display: -webkit-box;
    box-orient: vertical;
    /*! autoprefixer:off */
    -webkit-box-orient: vertical;
     /* autoprefixer:on */
    -webkit-line-clamp: 2;
    overflow: hidden;
}
.row {
    -webkit-box-direction: normal;
    -webkit-box-orient: horizontal;
    -moz-flex-direction: row;
    -webkit-flex-direction: row;
    flex-direction: row;
}

.column {
    -webkit-box-orient: vertical;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
}
.flex {
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
}
/* 水平居中 */
.f-center {
    -webkit-box-pack: center;
    -moz-justify-content: center;
    -webkit-justify-content: center;
    justify-content: center;
}
/* 水平左右对齐 */
.f-between {
    -webkit-box-pack: space-between;
    -moz-justify-content: space-between;
    -webkit-justify-content: space-between;
    justify-content: space-between;
}
/* 水平居中对齐 */
.f-around {
    -webkit-box-pack: space-around;
    -moz-justify-content: space-around;
    -webkit-justify-content: space-around;
    justify-content: space-around;
}
/* 上下居中 */
.f-align {
    -webkit-box-align: center;
    -moz-align-items: center;
    -webkit-align-items: center;
    align-items: center;
}
/* 换行显示 */
.f-wrap{
    -webkit-flex-wrap:wrap;
    flex-wrap:wrap;
}

/* 开始 */
.f-start {
    -webkit-box-pack: flex-start;
    -moz-justify-content: flex-start;
    -webkit-justify-content: flex-start;
    justify-content: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/App.vue